import { render, staticRenderFns } from "./WsStateTulpaSections.vue?vue&type=template&id=392a5eeb&"
import script from "./WsStateTulpaSections.vue?vue&type=script&lang=js&"
export * from "./WsStateTulpaSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports